import heroSection from "../components/heroSection/locals/en.json";
import aboutSection from "../components/aboutSection/locals/en.json";
import serviceSection from "../components/serviceSection/locals/en.json";
import numbersSection from "../components/numbersSection/locals/en.json";
import reviewsSection from "../components/reviewsSection/locals/en.json";
import newsSection from "../components/newsSection/locals/en.json";


export default {
  heroSection,
  aboutSection,
  serviceSection,
  numbersSection,
  reviewsSection,
  newsSection,
};
